/**
 * Mirrors packages/amgfishprawncrab_v2/lib/core/constants/api_constants.dart
 * + game_constants.dart for endpoints, game keys, and the reference resolution
 * used by the Flutter web build.
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

export const GAME_KEY_SINGLE = 'FPC1';
export const GAME_KEY_MULTI = 'FPCM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/fishprawncrabhub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_fishPrawnCrab_v2/web/index.html */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

export const DEFAULT_USER_NAME = 'user2';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 1,
  maxBet: 100000,
  chipValues: [1, 5, 10, 20, 50, 100] as const,
};

/** ms — auto-advance new round after showing the result panel */
export const NEW_ROUND_DELAY_MS = 4500;

/** ms — payout (chip distribution) delay after dice bowl 'OutEnd'. */
export const PAYOUT_DELAY_MS = 1500;

/** ms — safety-net fallback if Rive DiceBowlEnd 'OutEnd' never fires. */
export const OUTEND_SAFETY_MS = 8000;
